import styled from 'styled-components';
import { rSize } from 'core/util/ResponsiveSizeAdapter';
import { Cart } from '../../../domain/entities/Cart';
import { priceDisplay } from '../../../../configuration/helpers/HelperFunctions';
import {
  appCurrency,
  PICKUP_ORDER_ROW_LABEL,
  PICKUP_PAYMENT_NOTE,
  TAKE_OUT_DELIVERY_QUESTION,
} from '../../../../configuration/helpers/constants';

interface OrderDetailsProps {
  stateCart: Cart | undefined;
  deliveryCost: number;
}

export const OrderDetails = ({ stateCart, deliveryCost }: OrderDetailsProps) => {
  const rStyles = {
    global: {
      h4: { fontSize: rSize(24) },
      p: { fontSize: rSize(18) },
    },
  };

  return (
    <Wrapper className="widget">
      <h4 style={{ ...rStyles.global.h4 }} className="widget-title">
        Total de la commande
      </h4>
      <table className="table-bordered check-tbl">
        <tbody>
          <tr>
            <td style={{ ...rStyles.global.p }}>Sous-total</td>
            <td className="product-price" style={{ ...rStyles.global.p }}>
              {priceDisplay(stateCart?.total)}
            </td>
          </tr>
          <tr>
            <td style={{ ...rStyles.global.p }}>{PICKUP_ORDER_ROW_LABEL}</td>
            <td style={{ ...rStyles.global.p }}>
              {TAKE_OUT_DELIVERY_QUESTION} (0 {appCurrency.symbol})
            </td>
          </tr>
          <tr>
            <td style={{ ...rStyles.global.p }}>Total</td>
            <td className="product-price-total" style={{ ...rStyles.global.p }}>
              {priceDisplay((stateCart?.total ?? 0) + deliveryCost)}
            </td>
          </tr>
        </tbody>
      </table>
      <p className="pickup-note" style={{ ...rStyles.global.p }}>
        {PICKUP_PAYMENT_NOTE}
      </p>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  td {
    width: 50%;
  }
  .pickup-note {
    margin-top: 12px;
  }
`;
